import { type UseFormReturn, useWatch } from 'react-hook-form';

import { CampoSenha } from '@/ui/components/campo-senha';
import { MedidorForcaSenha } from '@/ui/components/medidor-forca-senha';
import { Campo } from '@/ui/primitives/input';

export interface FormularioTrocaSenha {
  senhaAtual: string;
  novaSenha: string;
  confirmacao: string;
}

interface CamposTrocaSenhaProps {
  formulario: UseFormReturn<FormularioTrocaSenha>;
  /** Senha definida pela administração: o primeiro campo é a "Senha recebida". */
  pendente: boolean;
  /** E-mail de quem troca — vai num campo oculto para o gerenciador de senhas saber de quem é. */
  email: string;
}

/** Os três campos da troca de senha, com o olho em todos e o medidor na nova senha. */
export function CamposTrocaSenha({ formulario, pendente, email }: CamposTrocaSenhaProps) {
  const erros = formulario.formState.errors;
  const novaSenha = useWatch({ control: formulario.control, name: 'novaSenha' });
  return (
    <>
      {/* O Chrome pede um campo de usuário (pode ser oculto) em todo formulário de senha:
          sem ele o gerenciador não sabe a que conta salvar a nova senha. */}
      <input type="text" hidden readOnly autoComplete="username" value={email} />
      <Campo rotulo={pendente ? 'Senha recebida' : 'Senha atual'} erro={erros.senhaAtual?.message}>
        {(a11y) => (
          <CampoSenha
            autoComplete="current-password"
            autoFocus
            {...a11y}
            {...formulario.register('senhaAtual')}
          />
        )}
      </Campo>
      <Campo
        rotulo="Nova senha"
        ajuda="Pelo menos 12 caracteres. Uma frase longa é mais fácil de lembrar."
        erro={erros.novaSenha?.message}
      >
        {(a11y) => (
          <>
            <CampoSenha
              autoComplete="new-password"
              {...a11y}
              {...formulario.register('novaSenha')}
            />
            <MedidorForcaSenha senha={novaSenha} />
          </>
        )}
      </Campo>
      <Campo rotulo="Confirme a nova senha" erro={erros.confirmacao?.message}>
        {(a11y) => (
          <CampoSenha
            autoComplete="new-password"
            {...a11y}
            {...formulario.register('confirmacao')}
          />
        )}
      </Campo>
    </>
  );
}
